<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Редактировать страницу</strong>
                </CCardHeader>
                <CCardBody>
                    <AdsCampaignTabLinks :campaignId="adsCampaign.id" />
                    <CForm>
                        <CRow form class="form-group" style="margin-top: 20px">
                            <CCol tag="label" class="col-form-label" sm="3">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="adsCampaign.enabled"
                                />
                            </CCol>
                        </CRow>

                        <CInput
                            v-model="adsCampaign.name"
                            horizontal
                            label="Название"
                            placeholder="Введите название"
                        />

                        <CInput
                            v-model="adsCampaign.url"
                            horizontal
                            label="Ссылка страницы"
                            placeholder="Введите ссылку на страницу"
                        />

                        <template v-for="(block, blockIndex) in blocks">
                            <CCard class="mt-3" :key="'block-' + blockIndex">
                                <CCardHeader>
                                    <strong>Блок {{ blockIndex + 1 }}</strong>
                                </CCardHeader>
                                <CCardBody>
                                    <div v-if="block.picture" class="form-row">
                                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                                        <CCol sm="9" class="col-form-label">
                                            <CImg
                                                :src="pictureUrl(block.picture)"
                                                class="m2"
                                                width="200" />
                                        </CCol>
                                    </div>
                                    <CInputFile
                                        :ref="'picture' + blockIndex"
                                        :label="'Изображение'"
                                        horizontal
                                        @change="(e) => selectPicture(blockIndex, e)"
                                    />

                                    <CInput
                                        v-model="block.title"
                                        horizontal
                                        label="Заголовок"
                                        placeholder="Введите заголовок"
                                    />

                                    <CTextarea
                                        v-model="block.description"
                                        horizontal
                                        rows="5"
                                        label="Описание"
                                        placeholder="Введите описание"
                                    />
                                </CCardBody>
                            </CCard>

                            <CCard class="mt-2">
                                <CCardBody>
                                    <CInput
                                        v-model="block.button_name"
                                        horizontal
                                        label="Текст на кнопке"
                                        placeholder="Введите текст на кнопке"
                                    />

                                    <CInput
                                        v-model="block.button_color"
                                        horizontal
                                        label="Цвет кнопки (например: #FFFFFF)"
                                        placeholder="Введите цвет кнопки"
                                    />

                                    <div class="form-row">
                                        <CCol sm="3" class="col-form-label">Открывается при клике на кнопку:</CCol>
                                        <CCol sm="9" class="col-form-label">
                                            <CSelect
                                                inline
                                                :value="block.link_type"
                                                :options="linkTypes"
                                                @change="(e) => updateBlockLinkType(blockIndex, e)"
                                            />
                                        </CCol>
                                    </div>

                                    <CInput
                                        v-model="block.button_url"
                                        horizontal
                                        label="Ссылка"
                                        placeholder="Введите ссылку для кнопки"
                                    />
                                </CCardBody>
                            </CCard>
                        </template>

                        <div v-if="blocks.length < 3" class="mt-3">
                            <CButton color="secondary" @click="addBlock">Добавить блок</CButton>
                        </div>

                        <CCard v-if="adsCampaign.id" class="mt-3">
                            <CCardBody>
                                <AdsCampaignEventsList
                                    :adsCampaignId="adsCampaign.id"
                                />
                            </CCardBody>
                        </CCard>

                        <CCard class="mt-3">
                            <CCardBody>
                                <CTextarea
                                    v-model="adsCampaign.footer_description"
                                    horizontal
                                    rows="5"
                                    label="Описание под событиями"
                                    placeholder="Введите описание"
                                />
                            </CCardBody>
                        </CCard>
                    </CForm>
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" class="mr-3" @click="save">Сохранить</CButton>
                    <CButton color="light" class="mr-3" @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import AdsCampaignTabLinks from '@/components/ads-campaigns/AdsCampaignTabLinks';
import AdsCampaignEventsList from '@/components/ads-campaigns/AdsCampaignEventsList';
import { CCardBody, CTextarea } from '@coreui/vue';

export default {
    name: 'EditAdsCampaign',
    components: {
        AdsCampaignTabLinks,
        AdsCampaignEventsList,
    },
    data() {
        return {
            adsCampaign: {
                id: null,
                name: '',
                title: '',
                description: '',
                footer_description: '',
                block: false,
                button_name: '',
                button_color: '',
                button_url: '',
                link_type: 'none',
                url: '',
                picture: '',
                enabled: false,
            },
            blocks: [],
            selectedPictures: {},
            editor: null,
            footerEditor: null,

            linkTypes: [
                {
                    label: 'Ничего',
                    value: 'none',
                },
                {
                    label: 'Ссылка на страницу',
                    value: 'link',
                },
                {
                    label: 'Внешняя ссылка',
                    value: 'external_link',
                },
            ],
        };
    },
    async mounted() {
        try {
            const resp = await this.axios.get(`/ads-campaigns/${this.$route.params.id}`);
            this.adsCampaign = resp.data;
            this.normalizeBlocks();
        } catch (error) {
            console.log(error);
            this.$root.$emit('showError', 'Ошибка загрузки.');
        }
    },
    methods: {
        getEmptyBlock() {
            return {
                picture: '',
                title: '',
                description: '',
                button_name: '',
                button_color: '',
                link_type: 'none',
                button_url: '',
            };
        },
        normalizeBlocks() {
            const c = this.adsCampaign;
            if (Array.isArray(c.blocks) && c.blocks.length > 0) {
                this.blocks = c.blocks.slice(0, 3).map((b) => ({
                    ...this.getEmptyBlock(),
                    ...b,
                }));
            } else {
                this.blocks = [
                    {
                        ...this.getEmptyBlock(),
                        picture: c.picture || '',
                        title: c.title || '',
                        description: c.description || '',
                        button_name: c.button_name || '',
                        button_color: c.button_color || '',
                        link_type: c.link_type || 'none',
                        button_url: c.button_url || '',
                    },
                ];
            }
        },
        addBlock() {
            if (this.blocks.length < 3) {
                this.blocks.push(this.getEmptyBlock());
            }
        },
        selectPicture(blockIndex, fileListOrEvent) {
            const file =
                (fileListOrEvent && fileListOrEvent[0]) ||
                (fileListOrEvent && fileListOrEvent.target && fileListOrEvent.target.files && fileListOrEvent.target.files[0]);
            this.$set(this.selectedPictures, blockIndex, file || null);
        },
        pictureUrl(picture) {
            return picture ? process.env.VUE_APP_STATIC_BASE_URL + '/' + picture : '';
        },
        updateBlockLinkType(blockIndex, e) {
            const val = (e && e.target ? e.target.value : e) || 'none';
            this.blocks[blockIndex].link_type = val;
        },
        async save() {
            try {
                if (!this.adsCampaign.name) {
                    this.$root.$emit('showError', 'Введите название.');
                    return;
                }
                if (!this.adsCampaign.url) {
                    this.$root.$emit('showError', 'Введите ссылку на страницу.');
                    return;
                }

                for (let i = 0; i < this.blocks.length; i++) {
                    const file = this.selectedPictures[i];
                    if (file) {
                        const formData = new FormData();
                        formData.append('file', file);
                        const resp = await this.axios.post('/files/upload', formData);
                        this.blocks[i].picture = resp.data.filename;
                    }
                }

                this.adsCampaign.blocks = this.blocks.map((b) => ({
                    picture: b.picture || null,
                    title: b.title || null,
                    description: b.description || null,
                    button_name: b.button_name || null,
                    button_color: b.button_color || null,
                    link_type: b.link_type || 'none',
                    button_url: b.button_url || null,
                }));

                await this.axios.put(`/ads-campaigns/${this.adsCampaign.id}`, this.adsCampaign);

                this.goBack();
            } catch (error) {
                console.log(error);
                this.$root.$emit('showError', 'Ошибка сохранения.');
            }
        },
        goBack() {
            this.$router.push({ path: `/ads-campaigns` });
        },
    },
};
</script>

<style>
</style>
